export default class Vacancy {
    uuid: string = '';
    title: string = '';
    description: string = '';
    hours?: string;
    role?: string;
    location?: string;
    link: string = '';
    image: string = '';

    constructor(data: { [key: string]: any }) {
        Object.keys(data)
            .filter(key => data[key] != null && (<any>this)[key] != null)
            .forEach(key => (<any>this)[key] = data[key]);
    }
};